import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "../Dashboard";
import { toast } from "sonner";
import { btn, btnGhost, card, errMsg, field } from "./ui";

export default function StaffingOutreach() {
    const [candidates, setCandidates] = useState([]);
    const [rows, setRows] = useState([]);
    const [candidateId, setCandidateId] = useState("");
    const [body, setBody] = useState("");
    const [campaignId, setCampaignId] = useState("");
    const [leadId, setLeadId] = useState("");
    const [reason, setReason] = useState("");

    const load = () => api.get("/ats-core/outreach").then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
    useEffect(() => {
        api.get("/ats-core/candidates", { params: { limit: 200 } }).then((r) => setCandidates(r.data)).catch(() => {});
        load();
    }, []);

    const create = async (e) => {
        e.preventDefault();
        try {
            const r = await api.post("/ats-core/outreach", {
                candidate_id: candidateId,
                body,
                scaliq_campaign_id: campaignId || null,
                scaliq_lead_id: leadId || null,
                actor_type: "human",
            });
            toast.success(`Aangemaakt als ${r.data.status}. Nog niet verzonden.`);
            setBody("");
            await load();
        } catch (err) {
            toast.error(errMsg(err));
        }
    };

    const act = async (id, action) => {
        try {
            const payload = action === "hold" || action === "reject" ? { reason } : {};
            const r = await api.post(`/ats-core/outreach/${id}/${action}`, payload);
            toast.success(r.data.status || action);
            await load();
        } catch (err) {
            toast.error(errMsg(err));
            await load();
        }
    };

    return (
        <PageHeader
            title="Lichte outreach"
            subtitle="Altijd eerst Approve, Hold of Reject. Verzenden gaat alleen via ScalIQ en faalt zichtbaar als dat niet kan."
        >
            <form onSubmit={create} className={`${card} grid gap-3 mb-6`} data-testid="outreach-form">
                <select className={field} required value={candidateId} data-testid="outreach-candidate"
                    onChange={(e) => setCandidateId(e.target.value)}>
                    <option value="">Kandidaat</option>
                    {candidates.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
                </select>
                <textarea className={field} required rows={4} placeholder="Bericht" value={body} data-testid="outreach-body"
                    onChange={(e) => setBody(e.target.value)} />
                <div className="grid md:grid-cols-2 gap-3">
                    <input className={field} placeholder="ScalIQ campaign id (voor send)" value={campaignId}
                        onChange={(e) => setCampaignId(e.target.value)} />
                    <input className={field} placeholder="ScalIQ lead id (voor send)" value={leadId}
                        onChange={(e) => setLeadId(e.target.value)} />
                </div>
                <button className={`${btn} w-fit`} data-testid="outreach-create">Indienen ter approve</button>
            </form>

            <div className="mb-3">
                <input className={`${field} max-w-md`} placeholder="Reden voor Hold of Reject" value={reason}
                    data-testid="outreach-reason" onChange={(e) => setReason(e.target.value)} />
            </div>

            <div className="space-y-3" data-testid="outreach-list">
                {rows.map((m) => (
                    <div key={m.id} className={card} data-testid={`outreach-${m.id}`}>
                        <div className="flex flex-wrap items-center gap-2 mb-2">
                            <span className="text-white">{m.candidate_name}</span>
                            <span className="text-[10px] font-mono uppercase text-[var(--jr-amber)]" data-testid={`outreach-status-${m.id}`}>{m.status}</span>
                            <span className="text-[10px] text-[var(--jr-text-3)]">{m.provenance_actor} · {m.executor}</span>
                        </div>
                        <p className="text-sm text-[var(--jr-text-2)] whitespace-pre-wrap">{m.body}</p>
                        {m.send_error && <p className="mt-2 text-xs text-[var(--jr-error, #f87171)]">{m.send_error}</p>}
                        {m.reason && <p className="mt-2 text-xs text-[var(--jr-text-3)]">Reden: {m.reason}</p>}
                        <div className="flex flex-wrap gap-2 mt-3">
                            {m.status === "pending_approval" && (
                                <>
                                    <button className={btn} data-testid={`outreach-approve-${m.id}`} onClick={() => act(m.id, "approve")}>Approve</button>
                                    <button className={btnGhost} data-testid={`outreach-hold-${m.id}`} onClick={() => act(m.id, "hold")}>Hold</button>
                                    <button className={btnGhost} data-testid={`outreach-reject-${m.id}`} onClick={() => act(m.id, "reject")}>Reject</button>
                                </>
                            )}
                            <button className={btnGhost} data-testid={`outreach-send-${m.id}`} onClick={() => act(m.id, "send")}>
                                Verzend via ScalIQ
                            </button>
                        </div>
                    </div>
                ))}
                {!rows.length && <p className="text-sm text-[var(--jr-text-3)]">Geen lichte outreach.</p>}
            </div>
        </PageHeader>
    );
}
